<template>
  <content-list-page content-type="post"/>
</template>

<script>
import ContentListPage from "../../components/dashboard/Content/ContentListPage.vue";

export default {
  name: "Post",
  components: {ContentListPage},
};
</script>
